import { Injectable } from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';
import {filter} from "rxjs/operators";
import {ActivatedRoute} from "@angular/router";
import {VssUiNavModel} from '../modules/menu/menu.model';
import {VssUiTabModel} from '../modules/tab-group/tab-group.model';
import {cloneDeep} from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class VssTabDynamicService {
  private menuList: any[] = [];
  private dataTabSelector: VssUiTabModel[] = [];
  currentTabIndex: BehaviorSubject<number>;
  tabs: BehaviorSubject<any[]>;
  currentPage: BehaviorSubject<any>;
  logHis: BehaviorSubject<boolean>;
  actionEmit: BehaviorSubject<string>;
  activatedRoute: BehaviorSubject<ActivatedRoute>;
  public updateInfoTab: Subject<any> = new Subject<any>()

  constructor(
    private _activatedRoute: ActivatedRoute
  ) {
    this.tabs = new BehaviorSubject<any>([]);
    this.currentTabIndex = new BehaviorSubject<number>(0);
    this.currentPage = new BehaviorSubject<any>(null);
    this.logHis = new BehaviorSubject<any>(false);
    this.actionEmit = new BehaviorSubject<any>('');
    this.activatedRoute = new BehaviorSubject<ActivatedRoute>(_activatedRoute);
  }

  setActivatedRoute(v: ActivatedRoute) {
    this.activatedRoute.next(v)
  }

  getActivatedRoute() {
    return this.activatedRoute
  }

  emitAction(actionName: string) {
    this.actionEmit.next(actionName)
  }

  onAction(actionName: string) {
    return this.onAllAction().pipe(filter(x => x == actionName))
  }

  onAllAction() {
    return this.actionEmit
  }

  getCurrentTabs() {
    return this.tabs;
  }

  setCurrentTabs(tabs: any[]) {
    this.tabs.next(tabs);
  }

  getCurrentTabsIndex() {
    return this.currentTabIndex;
  }

  setCurrentTabsIndex(index: number) {
    this.currentTabIndex.next(index);
  }

  setDataTabSelector(dataTabSelector: VssUiTabModel[]){
    this.dataTabSelector = dataTabSelector;
  }

  getDataTabSelector(){
    return this.dataTabSelector;
  }

  getDataRoutes() {
    return this.dataTabSelector?.map((d, i) => ({id: i+1, ...d, ...this.menuList.find(t => t.url === d?.url)}))
  }

  setMenuList(menu:any[]){
    this.menuList = menu;
  }

  getMenuList(){
    return this.menuList;
  }

  setCurrentPage(page:any){
    this.currentPage.next(page);
  }

  getCurrentPage(){
    return this.currentPage;
  }

  getLogHis(){
    return this.logHis;
  }

  setLogHis(log:boolean){
    this.logHis.next(log);
  }
}
